<template>
  <div>
    <material-card
      :title="title"
      :color="$vuetify.theme.themes.light.success"
      icon="note_add"
      v-if="note"
    >
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-container>
            <v-row>
              <v-col cols="12" md="8">
                <no-autocomplete-textfield
                  v-model="note.Title"
                  :label="$t('globals.title')"
                  :rules="[$rules.required]"
                  autocomplete="off"
                  class="required"
                />
              </v-col>
              <v-col cols="12" md="4">
                <auto-select
                  :value.sync="note.Category"
                  :label="$t('globals.category')"
                  :items="categories"
                  :rules="[$rules.required]"
                  class="required"
                  :return-object="false"
                />
              </v-col>
              <v-col cols="12">
                <quill-editor v-model="note.Text" />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text @click="$emit('close')">{{ $t("globals.cancel") }}</v-btn>
        <v-btn :disabled="!valid" color="primary" :loading="saving" @click="save">{{
          $t("globals.save")
        }}</v-btn>
      </v-card-actions>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import AutoSelect from "@/components/AutoSelect";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
export default {
  components: { ErrorHandler, AutoSelect, NoAutocompleteTextfield },
  props: {
    note: {
      default: () => ({
        Title: "",
        Text: "",
        Category: null,
        EmployerId: "",
      }),
    },
    title: String
  },
  data: () => ({
    valid:true,
    error: null,
    categories: [
      "Other",
    ],
    saving: false,
  }),
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  methods: {
    ...mapActions("plansMembers", ["saveEmployerNote"]),
    async save() {
      this.error = null;
      this.saving = true;
      try {
        await this.saveEmployerNote({
          planIdentityId: this.selectedPlan.Id,
          employerIdentityId: this.note.EmployerId,
          payload: [this.note],
        });
        this.$emit("close");
      } catch (e) {
        console.error(e);
        this.error = e;
      } finally {
        this.saving = false;
      }
    },
  },
  mounted() {},
  watch: {
    note: {
      handler() {
        this.$refs.form.reset();
      },
    },
  },
};
</script>
